import axios from 'axios';
import ss from '../../../../Data/Session';

/**
 * @typedef {{
 *   id: string,
 *   data: {},
 * }} ContentsType
 * 
 * @typedef {import('./Session').sessionType} sessionType
 */

/**
 * 
 * @param {sessionType} session 
 * @param {string} query 
 * @param {number} limit 
 * @returns {Promise<ContentsType[]>}
 */
export async function readContents (serviceId, titleId, episodeId, snapshotId) {
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/webtoon/contents', {serviceId, titleId, episodeId, snapshotId,}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            if (res.data.siblings){
                res.data.siblings = res.data.siblings.map(num => `${num}`)
            }
            return res.data;

        }else{
            return res;
        }
    }catch(e){
        console.error(e)
        return { data:{ images:[]}, siblings: [], ...(e.response),};
    }
}

/**
 * 
 * @param {`https://static.webtoon.today/${string}`[]} images 
 * @returns {Promise<`https://static.webtoon.today/${string}`>}
 */
export async function getContentsAsZip (images) {
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/zip-staticfiles', {staticFiles: images}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return res.data.data;

        }else{
            return res;
        }
    }catch(e){
        console.error(e)
        return null;
    }
}
/**
 * 
 * @param {`https://static.webtoon.today/${string}`} zipName 
 * @returns {Promise<`https://static.webtoon.today/${string}`[] | null>}
 */
export async function spreadZipOnS3 (zipName) {
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/spread-zip', {zipName}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return res.data.data;

        }else{
            return res;
        }
    }catch(e){
        console.error(e)
        return null;
    }
}

/**
 * 
 * @param {{
 *  session: sessionType
 *  serviceId: string,
 *  titleId: string,
 *  snapshotId: string,
 *  data: {},
 * @returns {Promise<string>}
 */
export async function createContents ({contents}) {
    
    try{
        let res = await axios.put('https://challenge-api.webtoon.today/webtoon/contents', contents,{
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });

        if (res.data && res.data.code === 200){
            
            return res.data.key;

        }else{
            return [];
        }
    }catch(e){
        return [];
    }
}

/**
 * 
 * @param {{
*  session: sessionType
*  contents: ContentsType,
* @returns {Promise<string>}
*/
export async function updateContents ({contents,}) {
    try{
        let res = await axios.patch('https://challenge-api.webtoon.today/webtoon/contents', contents,{
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });

        if (res.data && res.data.code === 200){
            
            return res.data.key;

        }else{
            return [];
        }
    }catch(e){
        return [];
    }
}

/**
* 
* @param {{
*  session: sessionType
*  contents: ContentsType,
* @returns {Promise<string>}
*/
export async function deleteContents ({contents}) {
    try{
        let res = await axios.delete(`https://challenge-api.webtoon.today/webtoon/contents?serviceId=${contents.serviceId}&titleId=${contents.titleId}&episodeId=${contents.episodeId}&snapshotId=${contents.snapshotId}`,{
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });

        if (res.data && res.data.code === 200){
            
            return res.data.key;

        }else{
            return [];
        }
    }catch(e){
        return [];
    }
}

/**
 * 
 * @param {{serviceId: string, titleId:string}} props
 * @returns {Promise<string|null>}
 */
 export async function createContentsFromChallenge ({serviceId, titleId, episodeId, source, ...others}) {
    try{
        let res = await axios.put('https://challenge-api.webtoon.today/create-episode-from-challenge', {
            serviceId, titleId, episodeId, source, ...others
        }, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return res.data.urlArr;

        }else{
            return null;
        }
    }catch(e){
        return null;
    }
}